// all content is exported from content.js
import * as content from "../content/content.js";

const books = [
  {
    id: 1,
    title: "The Best Thing",
    cover: content.bestThing,
    description: `Saylor moves to Massachusetts for college with a clean slate after a traumatic past. She has all the intentions of starting over, but sometimes things don't always go as planned.\n
    But what happens when she meets a blue eyed hockey player and his best friend? Will they throw a wrench in her plans or show her an alternative path?\n`,
    firstChapter: content.bestThingPrev,
    wattpadLink: "https://www.wattpad.com/story/298076190-the-best-thing",
    continueLink: "https://www.wattpad.com/1178487920-the-best-thing-slipping-away",
    platform: "wattpad",
  },
  {
    id: 2,
    title: "Every Little Thing",
    cover: content.everyLittleThing,
    description: `Blake Hallows has faced more trauma in her twenty two years than most people face in their entire life. From losing her mom to cancer, to her high school sweetheart their second year of college in a terrible accident. Death has basically become numbing to her. But, with only a couple years left of college she has come to realize that she missed out on a lot. So, she makes a pact with herself to finally step out of her comfort zone and enjoy the time she has left.\n
    Ryder Alexander transfers over to UCSD his senior year which is highly unusual. He was offered the position as a starting quarterback because it’s number two in state and reluctantly accepted. The Aztecs lost their quarterback a couple years prior and have been using their backup but the team hasn’t been doing well. So Ryder is brought in to try and make a difference. What he doesn’t expect is to meet a blonde beauty who completely sweeps him off of his feet.\n
    Can Blake move on from her tragic past and open up her heart again to someone who might just be worthy of it? Or will the demons from her past come back to haunt them both.\n`,
    firstChapter: content.everyLittleThingPrev,
    wattpadLink: "https://www.wattpad.com/story/321894178-every-little-thing",
    continueLink: "https://www.wattpad.com/1268666993-every-little-thing-chapter-one",
    platform: "wattpad",
  },
  {
    id: 3,
    title: "Second Chances",
    cover: content.secondChances,
    description: `A sequel to The Best Thing.\n
    Feyre is a junior at Harvard and still reeling from the traumatizing loss of her childhood best friend/boyfriend. Her focus has been on school, work and moving away after graduating, she never knew that her brother's best friend would have such an impact on her life.\n
    He's broody, cocky and your typical hockey playing jock. But, you shouldn't always judge a book by it's cover right? Because to Storm there just maybe be more than meets the eye. If only Fey can get past the rumors, gossip and asshole persona that he puts up as shield.\n`,
    firstChapter: content.secondChancesPrev,
    wattpadLink: "https://www.wattpad.com/story/316293809-second-chances",
    continueLink: "https://www.wattpad.com/1291179654-second-chances-remembering-you",
    platform: "wattpad",
  },
  {
    id: 4,
    title: "The Ghost of You",
    cover: content.ghostOfYou,
    description: `Carter's entire world is turned upside down after the tragic loss of his twin brother. He's destructive, angry and blames himself for his death.\n
    Madden is one of Carter's childhood best friends whose had a crush on him since they were kids. But, they're relationship dramatically changed after the death of his brother. She refuses to give up on him, regardless of how hard he tries to push her away.\n
    What happens if she's his savior, but he's her destruction?\n`,
    firstChapter: content.ghostOfYouPrev,
    wattpadLink: "https://www.wattpad.com/story/336906106-the-ghost-of-you",
    continueLink: "https://www.wattpad.com/1324581709-the-ghost-of-you-destruction",
    platform: "wattpad",
  },
  {
    id: 5,
    title: "Lose You",
    cover: content.loseYou,
    description: `Aria is a sophomore in college, living in beautiful Oceanside, CA. She's in a sorority with her best friend and living her best life until she gets a bad grade in one of her classes. She hates asking for help, but caves in and looks for a tutor.\n
    Little did she know that Ace Edgewood, hockey captain and campus heartthrob was going to show up to her tutor session. They don't start off on the right foot and Ace has some skeletons in his closet that he needs to work through.\n
    Can these two turn an unlikely friendship into more?\n`,
    firstChapter: content.loseYouPrev,
    wattpadLink: "https://www.wattpad.com/story/220056588-lose-you",
    continueLink: "https://www.wattpad.com/1309312765-lose-you-1",
    platform: "wattpad",
  },
  {
    id: 6,
    title: "Truth or Dare",
    cover: content.truthOrDare,
    description: `Paisley accepts a dare or two... a night with the hot, single and infamous Maverick Warren. Hockey captain and campus heartthrob. Is it all fun and games or will this lead to more than either of them could have ever imagined?\n`,
    firstChapter: content.truthOrDarePrev,
    wattpadLink: "",
    continueLink: "",
    kindleLink:
      "https://www.amazon.com/Truth-Dare-Alyssa-Potter-ebook/dp/B0CV5P7SHN/ref=sr_1_1?keywords=alyssa+potter&s=digital-text&sr=1-1",
    platform: "kindle",
  },
];

export default books;
